const navDirections = Object.freeze({
    next: 1,
    previous: -1,
    reset: 100,
    google: 11,
    current: 0,
})
function _getDisplayArray(label, range) {
    const length = range.exclusiveEnd - range.start
    let start = range.start
    return Array(length)
        .fill(label)
        .map((value, index) => {
            let quantity = start + index
            value = quantity === 1 ? value.slice(0, -1) : value
            return quantity.toString() + value
        })
}
function _getValueArray(range) {
    const length = range.exclusiveEnd - range.start
    let start = range.start
    return Array(length)
        .fill(null)
        .map((_, index) => {
            return (start + index).toString()
        })
}

const strandOptionRange = { start: 1, exclusiveEnd: 7 }
const spacingConfig_Meters = [3, 1, 13]
const spacingConfig_Feet = [10, 2, 21]
const cornerOptionRange = { start: 1, exclusiveEnd: 51 }
const gateOptionRange = { start: 1, exclusiveEnd: 16 }
const endOptionRange = { start: 1, exclusiveEnd: 51 }

const appUtilities = {
    // specialCharTM: '\u{00AE}',
    navDirections: navDirections,
    energizerTrigger: 12,
    tensionKitTrigger: 834,
    loggingContent: '',
    loggingArray: [],
    loggingBoolean: true, // developer switch

    addLogging(log) {
        if (typeof log === 'string') {
            this.loggingContent += log
            this.loggingContent += '\r\n'
        } else {
            this.loggingArray.push(log)
        }
    },

    reportLogging() {
        if (this.loggingBoolean && this.loggingContent !== '') {
            this.loggingArray.forEach(() => {
                // const star = '*'
                // console.log(`${star.repeat(40)}`)
                // console.table(obj)
            })
            // console.log(this.loggingContent)
        }
    },
    clearLog() {
        this.loggingContent = ''
        this.loggingArray = []
    },

    getParamString(params) {
        let query = ''
        const paramKeys = Object.keys(params)
        if (paramKeys.length !== 0) {
            // TODO: 05/19/23 nullish eval
            let queryArr = paramKeys.map(
                (v) =>
                    `${encodeURIComponent(v)}=${encodeURIComponent(params[v])}`
            )
            query = queryArr.join('&')
        }
        // console.log(`query is ... ${query}`)
        return query === '' ? '' : '?' + query
    },

    getProximalPages(searchParams) {
        // are we at / or g2a or g2b or g3?
        let currentPg = searchParams.get('p')
        // let pgID = p.slice(-1)
        return currentPg
    },

    pgIDFromPathname(pathname) {
        // landing page should just be '../calc/'
        if (pathname === '/') return '1'
        if (pathname.includes('pgGgl')) {
            return pathname.slice(3)
        }
        return pathname.slice(-1)
    },

    getMeasureDisplayArray() {
        return [
            'Measure in feet',
            'Measure in meters',
            // 'Measure in a square shaped acreage',
        ]
    },
    getMeasureValueArray() {
        return ['feet', 'meters'] //'acres']
    },
    getStrandDisplayArray() {
        return _getDisplayArray(' Strands', strandOptionRange)
    },
    getStrandValueArray() {
        return _getValueArray(strandOptionRange)
    },
    getColorDisplayArray() {
        return ['White', 'Black', 'Checkered']
    },
    getColorValueArray() {
        return ['0', '1', '2']
    },

    getSpacingDisplayArray(unit) {
        // unit = unit === 'acres' ? 'feet' : unit
        const [origin, multiplier, rangeLength] =
            unit === 'feet' ? spacingConfig_Feet : spacingConfig_Meters

        return Array(rangeLength)
            .fill(null)
            .map((_, index) => {
                return `${origin + index * multiplier} ${unit}`
            })
    },
    getSpacingValueArray(unit) {
        // unit = unit === 'acres' ? 'feet' : unit
        const [origin, multiplier, rangeLength] =
            unit === 'feet' ? spacingConfig_Feet : spacingConfig_Meters

        let ar = Array(rangeLength)
            .fill(null)
            .map((_, index) => {
                return `${origin + index * multiplier}`
            })

        //maintain all values in state as measures in feet
        if (unit !== 'feet') {
            // ensure spacing conservatively low to secure enough post fastners etc.
            ar = [...ar].map((value) => {
                return `${Math.ceil((parseInt(value, 10) * 3.28984) / 2) * 2}`
            })
        }
        return ar
    },

    getCornerDisplayArray() {
        return _getDisplayArray('  Corners', cornerOptionRange)
    },
    getCornerValueArray() {
        return _getValueArray(cornerOptionRange)
    },

    getGateDisplayArray() {
        return _getDisplayArray(' Gates', gateOptionRange)
    },
    getGateValueArray() {
        return _getValueArray(gateOptionRange)
    },

    getEndDisplayArray() {
        let arr = _getDisplayArray(' Ends', endOptionRange)
        return ['No Ends', ...arr]
    },
    getEndValueArray() {
        let arr = _getValueArray(endOptionRange)
        return ['0', ...arr]
    },
    determineBraceDisabling(paramKey, controlSessionObj) {
        if (paramKey.includes('_hbrace')) {
            let matsParamKey = paramKey.slice(0, 1) + '_mats'
            if (controlSessionObj[matsParamKey] == '1') {
                //  if mats is 'Tree'
                return true
            }
        }
        return false
    },
    readableFenceElementCalc({
        elementArrayKey,
        paramQty,
        productID,
        neededQty,
        strands,
        numOfElements,
        tPostCapAdjustment,
    }) {
        const tPostCapRpt = tPostCapAdjustment
            ? `The adjustment for the t post caps is ${tPostCapAdjustment}`
            : ``
        const fenceElement = { 0: 'post', 1: 'corner', 2: 'end', 3: 'gate' }
        const matsID = { 0: 'Wood/Pipe', 1: 'Tree' }
        const braceID = { 0: 'Braid', 1: 'Wood', 2: 'None' } // { 0: 'None' , 1: 'Braid', 2: 'Wood',  }

        const [elementType, mats, braceMats] = elementArrayKey.split('')

        return `
        For all ${fenceElement[elementType]}s,
        the key was ${elementArrayKey},
        meaning for each strand on a ${fenceElement[elementType]} element where the  
        material to be used is ${matsID[mats]}, and the value 
        for bracing is ${braceID[braceMats]},
        it would require ${paramQty} ${productID}. 
        The total needed qty is ${neededQty} ${productID}, 
        given ${strands} strands, and ${numOfElements} ${fenceElement[elementType]}. 
        ${tPostCapRpt}

        -----

        `
    },

    perimeterCalc(fencePosts) {
        // console.log('fencePost in perimeterCalc', fencePosts)
        if (!window.google?.maps) return 0
        const len = fencePosts.length
        if (len < 2) return 0
        let [firstOfAPair, ...rest] = fencePosts
        const augmentedArray = len === 2 ? [...rest] : [...rest, firstOfAPair] //  solves for the final calc between last post and first in reduce function

        let perimeter = augmentedArray.reduce((acc, secondOfAPair) => {
            acc =
                acc +
                window.google.maps.geometry.spherical.computeDistanceBetween(
                    firstOfAPair,
                    secondOfAPair
                )
            firstOfAPair = secondOfAPair
            return acc
        }, 0)
        perimeter = Math.ceil(perimeter)
        // console.log('perimeter ', perimeter)
        return perimeter
    },

    areaCalc(fencePosts) {
        // return acres -> sq meters google provides
        // console.log('fencePost in areaCalc', fencePosts)
        if (!window.google?.maps) return 0
        const len = fencePosts.length
        if (len < 3) return 0

        const polygon = new window.google.maps.Polygon({
            paths: fencePosts,
        })

        const sqMeter = window.google.maps.geometry.spherical.computeArea(
            polygon.getPath()
        )

        const area = (sqMeter * 0.00025).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) //"1.50"
        return area
    },
    getSizeInUnitPreferred(unit, inMeters) {
        if (!unit || !inMeters) return 0
        let toPreferredUnit = {
            meters: (inMeters) => inMeters.toLocaleString(),
            feet: (inMeters) =>
                Math.ceil(inMeters * 3.280839895).toLocaleString(),
        }

        return toPreferredUnit[unit](inMeters)
    },

    capitalize(term) {
        if (!term) return ''
        const capitalize = [
            ...term.slice(0, 1).toUpperCase(),
            ...term.slice(1),
        ].join('')

        return capitalize
    },
    rangeModifier(itemQty) {
        let howManyPowersOf10 = Math.floor(Math.log10(itemQty))
        howManyPowersOf10 = howManyPowersOf10 > 0 ? howManyPowersOf10 : 1

        const rangeIncrement = 10 ** howManyPowersOf10

        const portionOfIncrement = (itemQty % rangeIncrement) / rangeIncrement
        const addedMarginInRange =
            portionOfIncrement > 0.65 ? rangeIncrement : 0
        const multiplesOfRangeIncrement = Math.floor(
            (itemQty + rangeIncrement) / rangeIncrement
        )
        const DEFAULTRANGE = 51
        const calcRange =
            rangeIncrement * multiplesOfRangeIncrement + addedMarginInRange + 1
        return Math.max(calcRange, DEFAULTRANGE)
    },
}
export default appUtilities
